import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { forwardRef } from 'react';
import createElement from "react-native-web/dist/exports/createElement";
import findNodeHandle from "react-native-web/dist/exports/findNodeHandle";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";
import CameraModule from "./CameraModule/CameraModule";
import CameraManager from "./ExponentCameraManager.web";

var ExponentCamera = function (_React$Component) {
  _inherits(ExponentCamera, _React$Component);

  var _super = _createSuper(ExponentCamera);

  function ExponentCamera() {
    var _this;

    _classCallCheck(this, ExponentCamera);

    _this = _super.apply(this, arguments);
    _this.state = {
      type: null
    };

    _this._updateCameraProps = function _callee(_ref) {
      var type, pictureSize, webCameraSettings, _assertThisInitialize, camera, actualCameraType;

      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = _ref.type, pictureSize = _ref.pictureSize, webCameraSettings = _objectWithoutProperties(_ref, ["type", "pictureSize"]);
              _assertThisInitialize = _assertThisInitialized(_this), camera = _assertThisInitialize.camera;

              if (camera) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return _regeneratorRuntime.awrap(camera.setTypeAsync(type));

            case 6:
              _context.next = 8;
              return _regeneratorRuntime.awrap(camera.updateWebCameraSettingsAsync(webCameraSettings));

            case 8:
              _context.next = 10;
              return _regeneratorRuntime.awrap(camera.ensureCameraIsRunningAsync());

            case 10:
              actualCameraType = camera.getActualCameraType();

              if (actualCameraType !== _this.state.type) {
                _this.setState({
                  type: actualCameraType
                });
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.getCamera = function () {
      if (_this.camera) {
        return _this.camera;
      }

      throw new Error('Camera is not defined yet!');
    };

    _this.getAvailablePictureSizes = function _callee2(ratio) {
      var camera;
      return _regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              camera = _this.getCamera();
              return _context2.abrupt("return", camera.getAvailablePictureSizes(ratio));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.takePicture = function _callee3(options) {
      var camera;
      return _regeneratorRuntime.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              camera = _this.getCamera();
              return _context3.abrupt("return", camera.takePicture(_objectSpread(_objectSpread({}, options), {}, {
                onPictureSaved: _this.props.onPictureSaved
              })));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.getAvailableCameraTypesAsync = function _callee4() {
      var camera;
      return _regeneratorRuntime.async(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              camera = _this.getCamera();
              _context4.next = 3;
              return _regeneratorRuntime.awrap(camera.getAvailableCameraTypesAsync());

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.resumePreview = function _callee5() {
      var camera;
      return _regeneratorRuntime.async(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              camera = _this.getCamera();
              _context5.next = 3;
              return _regeneratorRuntime.awrap(camera.resumePreview());

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.pausePreview = function _callee6() {
      var camera;
      return _regeneratorRuntime.async(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              camera = _this.getCamera();
              _context6.next = 3;
              return _regeneratorRuntime.awrap(camera.stopAsync());

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.onCameraReady = function () {
      if (_this.props.onCameraReady) {
        _this.props.onCameraReady();
      }
    };

    _this.onMountError = function (_ref2) {
      var nativeEvent = _ref2.nativeEvent;

      if (_this.props.onMountError) {
        _this.props.onMountError({
          nativeEvent: nativeEvent
        });
      }
    };

    _this._setRef = function (ref) {
      if (!ref) {
        _this.video = null;

        if (_this.camera) {
          _this.camera.stopAsync();

          _this.camera = undefined;
        }

        return;
      }

      _this.video = findNodeHandle(ref);
      _this.video.webkitPlaysinline = true;
      _this.camera = new CameraModule(ref);
      _this.camera.onCameraReady = _this.onCameraReady;
      _this.camera.onMountError = _this.onMountError;

      _this._updateCameraProps(_this.props);
    };

    return _this;
  }

  _createClass(ExponentCamera, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.camera) {
        this.camera.stopAsync();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      this._updateCameraProps(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var pointerEvents = this.props.pointerEvents;
      var isMuted = true;
      var isFrontFacingCamera = this.state.type === CameraManager.Type.front;
      var style = {
        transform: isFrontFacingCamera ? [{
          scaleX: -1
        }] : undefined
      };
      return React.createElement(View, {
        pointerEvents: "box-none",
        style: [styles.videoWrapper, this.props.style]
      }, React.createElement(Video, {
        autoPlay: true,
        playsInline: true,
        muted: isMuted,
        pointerEvents: pointerEvents,
        ref: this._setRef,
        style: [StyleSheet.absoluteFill, styles.video, style]
      }), this.props.children);
    }
  }]);

  return ExponentCamera;
}(React.Component);

export { ExponentCamera as default };
var Video = forwardRef(function (props, ref) {
  return createElement('video', _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});
var styles = StyleSheet.create({
  videoWrapper: {
    flex: 1,
    alignItems: 'stretch'
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
});